var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.56 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "drink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M32.27,47.91c18.55,14.28,25.17,8.65,35.79,3.41,8.14-4,11.33-7.81,21.22-3.8V33h-57V47.91ZM8.64,8.64a29.53,29.53,0,0,1,41.74,0c.25.25.5.51.74.77l.77.6L34.16,27.75H68.71l4-13.49A3.42,3.42,0,0,1,74.53,12L91.46,2.5a3.43,3.43,0,0,1,3.35,6L79.07,17.31l-3.3,10.44H92a2.19,2.19,0,0,1,2.19,2.18h0V57.75c0,18.07-9.88,32.09-28.31,33.47v25.42H80.23c1.21,0,2.18,1.92,2.18,3.12s-1,3.12-2.18,3.12H44.12c-1.21,0-2.18-1.92-2.18-3.12s1-3.12,2.18-3.12H56.66V91.31c-19-.78-29.61-15-29.61-33.55V34.85L10.11,51.8l-.3-.39,0,0c-.38-.35-.76-.7-1.13-1.07a29.53,29.53,0,0,1,0-41.74Zm37.11,1.1a25.58,25.58,0,0,0-36,36l1.87-1.87A23,23,0,0,1,43.88,11.61l1.87-1.87ZM14.4,41.09,24,31.47H10.58a19,19,0,0,0,3.82,9.62ZM31.47,24l9.62-9.62a19,19,0,0,0-9.62-3.82V24ZM10.58,27.55H24.77l-10-10a19,19,0,0,0-4.16,10Zm17-2.78V10.58a19,19,0,0,0-10,4.16l10,10Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.4f0f82ca3f4b2995386d24a7960cfd52.svg";
export { ForwardRef as ReactComponent };